import { useState, type FormEvent } from 'react';
import { Knop } from '@qc/ui';
import { supabase } from '../supabase.js';
import { Veld } from './Veld.js';
import { controleerNieuwWachtwoord } from './wachtwoord.js';

export interface NieuwWachtwoordSchermProps {
  /** Het adres waarvoor het wachtwoord wordt gekozen, ter bevestiging op het scherm. */
  email: string;
  onKlaar: () => void;
  onAnnuleren: () => void;
}

/**
 * Nieuw wachtwoord kiezen, na de link uit de mail "Nieuw wachtwoord". De link
 * heeft de bezoeker al ingelogd; hier zet hij alleen nog het wachtwoord.
 */
export function NieuwWachtwoordScherm({ email, onKlaar, onAnnuleren }: NieuwWachtwoordSchermProps) {
  const [wachtwoord, setWachtwoord] = useState('');
  const [herhaling, setHerhaling] = useState('');
  const [fout, setFout] = useState<string | null>(null);
  const [bezig, setBezig] = useState(false);

  async function verzend(gebeurtenis: FormEvent) {
    gebeurtenis.preventDefault();
    const probleem = controleerNieuwWachtwoord(wachtwoord, herhaling);
    setFout(probleem);
    if (probleem !== null) return;

    setBezig(true);
    const { error } = await supabase.auth.updateUser({ password: wachtwoord });
    setBezig(false);
    if (error) {
      setFout('Opslaan lukte niet. Probeer het nog eens, of vraag een nieuwe link aan.');
      return;
    }
    onKlaar();
  }

  return (
    <div className="mx-auto flex min-h-full max-w-lg flex-col justify-center gap-6 p-8">
      <header>
        <p className="text-tekst-zacht">Quality Cashless</p>
        <h1 className="text-3xl font-bold">Nieuw wachtwoord kiezen</h1>
      </header>
      <p className="text-xl">
        Voor <strong>{email}</strong>.
      </p>

      <form onSubmit={(e) => void verzend(e)} className="flex flex-col gap-4">
        <Veld
          label="Nieuw wachtwoord"
          type="password"
          autoComplete="new-password"
          required
          value={wachtwoord}
          onChange={(e) => setWachtwoord(e.target.value)}
          toelichting="Minstens acht tekens."
        />
        <Veld
          label="Nog een keer"
          type="password"
          autoComplete="new-password"
          required
          value={herhaling}
          onChange={(e) => setHerhaling(e.target.value)}
        />

        {fout !== null && <p className="text-lg text-fout">{fout}</p>}

        <Knop nadruk="hoofd" type="submit" disabled={bezig} className="w-full">
          {bezig ? 'Bezig…' : 'Wachtwoord opslaan'}
        </Knop>
      </form>

      <Knop nadruk="stil" onClick={onAnnuleren} className="text-base">
        Toch niet, uitloggen
      </Knop>
    </div>
  );
}
